import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import QueueSearchForm from './QueueSearchForm';
import QueueSearchResults from './QueueSearchResults';
import Header from 'components/Header/Header';
import { useWithTitle } from 'utils/hooks/useWithTitle';
import { TourQueueRequests } from './TourQueueRequests';
import { useAppInfo } from 'utils/hooks/useAppInfo';

const QueueRequests: React.FC = () => {
  const { t } = useTranslation('Queues');
  useWithTitle(); // sets title to document

  const { queueResults, uniqOperations, uniqStates } = useAppInfo();
  const [canShowResults, setCanShowResults] = useState<boolean>(false);

  const renderedSteps = <TourQueueRequests />;
  return (
    <>
      <Header title={t('stateOfQueue')} TourComponent={renderedSteps} />
      <QueueSearchForm setCanShowResults={setCanShowResults} />
      {canShowResults && (
        <QueueSearchResults
          queueResults={queueResults}
          uniqOperations={uniqOperations}
          uniqStates={uniqStates}
        />
      )}
    </>
  );
};

export default QueueRequests;
